module.exports = __webpack_public_path__ + "26716ac68c392f2e8d3f66b4f715abe7.pdf";